import React from "react";
import { Box, Typography } from "@mui/material";

// eslint-disable-next-line import/prefer-default-export
export const BedKpiCard = ({
  title,
  value,
  icon,
  isActive = false,
  onClick
}: {
  title: string;
  value: number | undefined;
  icon: React.ReactNode;
  isActive?: boolean;
  onClick?: () => void;
}): React.ReactNode => (
  <Box
    sx={{
      border: 1,
      borderColor: "divider",
      borderRadius: "10px",
      display: "flex",
      height: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: isActive ? "rgba(0, 150, 84, 0.08)" : "#fff",
      "&:hover": {
        boxShadow: "0px 5px 10px rgb(0 150 84 / 25%)",
        cursor: "pointer"
      }
    }}
    py={3}
    px={4}
    onClick={onClick}
  >
    <Box>
      <Typography fontSize="16px">{title}</Typography>
      <Typography fontWeight="700" fontSize="25px" mt={1}>
        {value ?? 0}
      </Typography>
    </Box>

    <Box
      sx={{
        height: "48px",
        width: "48px",
        borderRadius: "24px",
        padding: "10px",
        backgroundColor: "rgba(0, 150, 84, 0.25)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      {icon}
    </Box>
  </Box>
);
